import React from 'react';
import Encryption from '../components/Encryption/Encryption';
import Faq from '../components/Faq/Faq';
// import Footer from '../components/Footer/Footer';
import Forms from '../components/Forms/Forms';
import Hero from '../components/Hero/Hero';
import ImageFeatures from '../components/ImageFeatures/ImageFeatures';
// import Navbar from '../components/Navbar/Navbar';
import PdfConversion from '../components/PdfConversion/PdfConversion';
import PdfEdit from '../components/PdfEdit/PdfEdit';
import PdfFeatures from '../components/PdfFeatures/PdfFeatures';
import Security from '../components/Security/Security';
import Testimonial from '../components/Testimonial/Testimonial';
import Download from '../components/Download/Download';

export default function HomePage() {
  return (
    <>
      <Hero />
      <Security />
      <Encryption />
      <PdfFeatures />
      <Forms />
      <PdfEdit />
      <ImageFeatures />
      <PdfConversion />
      <Testimonial />
      <Faq />
      <Download />
    </>
  );
}
